import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxLoaderIndicatorDirective } from 'ngx-loader-indicator';
import { InterceptService } from 'src/app/core/_base/crud';
import { AuthAdminGuard } from 'src/app/core/auth/guard/auth-admin.guard';
import { AuthAdminService } from 'src/app/core/auth/service/auth-admin.service';
import { FieldControlErrorModule } from 'src/app/shared/field-control-error/field-control-error.module';

import { TranslationModule } from '../i18n/translation.module';
import { AuthRoutingModule } from './auth-routing.module';
import { AuthComponent } from './auth.component';
import { ForgotPasswordInvalidTokenComponent } from './components/forgot-password-invalid-token/forgot-password-invalid-token.component';
import { ForgotPasswordResetComponent } from './components/forgot-password-reset/forgot-password-reset.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { LoginComponent } from './components/login/login.component';
import { ForgotPasswordTokenResolverGuard } from './components/forgot-password-reset/forgot-password-token-resolver.guard';

@NgModule({
  declarations: [
    AuthComponent,
    LoginComponent,
    ForgotPasswordComponent,
    ForgotPasswordResetComponent,
    ForgotPasswordInvalidTokenComponent,
  ],
  imports: [
    CommonModule,
    TranslationModule,
    AuthRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    FieldControlErrorModule,
    NgxLoaderIndicatorDirective,
    NgbPopoverModule,
  ],
  providers: [
    InterceptService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptService,
      multi: true,
    },
    ForgotPasswordTokenResolverGuard
  ],
})
export class AuthModule {
  static forRoot(): ModuleWithProviders<AuthModule> {
    return {
      ngModule: AuthModule,
      providers: [AuthAdminService, AuthAdminGuard],
    };
  }
}
